import { styled, typography } from '@pulse-web-ui/theme';

import { FieldValidationHintState } from './types';

export const Hint = styled.div<{
  $state?: FieldValidationHintState;
}>`
  ${typography.regular14};
  line-height: 20px;
  display: flex;
  gap: 4px;
  color: ${({ theme, $state }) =>
    $state === FieldValidationHintState.VALID
      ? theme.colors.text.success
      : $state === FieldValidationHintState.INVALID
        ? theme.colors.text.error
        : theme.colors.text.secondary};
  margin-bottom: 4px;
`;

export const IconContainer = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: auto;
  width: 20px;
  height: 20px;
`;

export const BulletIcon = styled.div`
  width: 7px;
  height: 7px;
  border-radius: calc(${({ theme }) => theme.common.radius} * 2);
  background-color: ${({ theme }) => theme.colors.text.secondary};
`;
